import { render, staticRenderFns } from "./AlbumFrameZone.vue?vue&type=template&id=446714a1&scoped=true&"
import script from "./AlbumFrameZone.vue?vue&type=script&lang=js&"
export * from "./AlbumFrameZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumFrameZone.vue?vue&type=style&index=0&id=446714a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446714a1",
  null
  
)

export default component.exports